export interface EditConfig<T> {
  allowEditing?: boolean;
  mode?: 'inline' | 'dialog';
  onRowClick?: (row: T) => void;
}
